import { Grid, Menu, MenuList } from '@material-ui/core'
import Color from 'color'
import DatePicker from 'Components/DatePicker'
import ListingModal from 'Components/ListingModal'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import ApercuImage from 'EurestoComponents/ApercuImage'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { browserHistory } from 'react-router'

moment.locale('fr')

export default React.memo(props => {
  const [object, setObject] = useState(props.object || props.defaultObject || {})
  const [actions, setActions] = useState([])
  const actionRef = useRef(null)

  const [imgs, setImgs] = useState([])
  const [scrollToAction, setScrollToAction] = useState(false)

  const [groupeUserOptions, setGroupeUserOptions] = useState([])
  useEffect(() => {
    const regroupement = Data.list(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur)
    const utilisateurs = Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, {
      civilite_id: {
        not: true,
        value: null
      }
    })
    let options = []
    regroupement.map(grp => {
      options.push({
        label: grp.libelle,
        value: grp.id,
        html: <strong>{grp.libelle}</strong>,
        archive_id: !grp.actif
      })

      options = options.concat((grp.utilisateurs || []).map(uid => ({
        label: (utilisateurs.find(u => u.id === uid) || {}).slibelle,
        html: <span style={{ paddingLeft: 5 }}>{(utilisateurs.find(u => u.id === uid) || {}).slibelle}</span>,
        value: uid,
        archive_id: (utilisateurs.find(u => u.id === uid) || {}).archive_id,
        groupe_id: grp.id
      })))
    })
    if ((utilisateurs || []).length > 0) {
      options.push({
        label: 'Utilisateurs',
        html: <Grid container onClick={e => e.stopPropagation()}
                    style={{ cursor: 'not-allowed', width: '100%', margin: 0, padding: 0 }} justify={'center'}
                    alignItems={'center'}><strong>Utilisateurs</strong></Grid>,
        value: null
      })
    }
    utilisateurs.map(user => {
      options.push({
        label: user.slibelle,
        value: user.id,
        archive_id: user.archive_id
      })
    })
    setGroupeUserOptions(options)
  }, [])

  useEffect(() => {
    if (scrollToAction && actionRef && actionRef.current) {
      actionRef && actionRef.current && actionRef.current.scrollIntoView({ behavior: 'smooth' })
      setScrollToAction(false)
    }
  })

  useEffect(() => {
    props.object && props.object.source && props.object.id && ApiRequest(project.api + 'messagerie', {
      requete: 'message',
      action: 'list',
      recherche: [{
        champ: 'source',
        valeur: props.object.source,
        operation: 'like'
      }, {
        champ: 'status',
        valeur: [1, null],
        operation: 'egal'
      }]
    }).then(result => {
      setScrollToAction(true)
      setActions(result && result.results || [])
    })
  }, [props.object])
  const [anchorDateInterventionActionEl, setAnchorDateInterventionActionEl] = useState({})
  const [anchorUserAssignActionEl, setAnchorUserAssignActionEl] = useState({})

  const onClickAction = (action) => _ => {
    browserHistory.push({
      pathname: '/crm/' + action.contact_id,
      state: {
        dossier_id: action.dossier_id && action.dossier_id || undefined,
        classeur_id: action.classeur_id,
        action_id: action.action_id,
        UserTabSelected: 2,
        dossier_status: action.status
      }
    })
  }

  const actionComponent = (action) => {
    return (
      <Grid container style={{
        margin: 0,
        padding: 0,
        width: '100%',
        position: 'relative',
      }}
            spacing={0}
            id={'message_action_' + action.id}
            key={action.id + '_' + action.date_modification}
            justify={'center'}
            direction={'column'}
            alignItems={'flex-start'}>
        {
          <div
            ref={action.id === object.id && actionRef || null}
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              overflowWrap: 'break-word',
              //wordBreak: 'break-all',
              whiteSpace: '-moz-pre-wrap',
              textAlign: 'left',
              lineHeight: '15px',
              padding: '10px 5px',
              width: '100%',
              border: `1px 
                  dashed
                  ${EurestoColor('EurestoPrimary')}`,
              borderTop: 0,
              borderLeft: 0,
              borderRight: 0,
              ...(action.id === object.id && {
                backgroundColor: Color(EurestoColor('EurestoError')).lighten(0.5).string()
              } || {})
            }}>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  action.message
              }}/>
            {action.lien &&
            <Grid container
                  style={{ height: '100%', margin: 0, padding: 0 }}
                  spacing={0} alignContent={'flex-start'}
                  justify={'flex-start'}>
              <Grid item style={{ height: '100%', margin: 0, padding: 0, position: 'relative' }}
                    onClick={() => {
                      setImgs(action.lien.split(',').map(img => ({ src: img })))
                    }}>
                <img width={'auto'} height={'auto'} src={action.lien.split(',')[0]} alt={action.lien.split(',')[0]}
                     style={{ maxWidth: 100, maxHeight: 100, cursor: 'pointer', padding: 5, }}/>
                <Grid container justify={'center'} alignItems={'center'} alignContent={'center'}
                      style={{ position: 'absolute', bottom: 0, right: 0, width: 20, height: 20, borderRadius: '50%' }}
                      className={'EurestoPrimary cursor-pointer EurestoText--text'}>{action.lien.split(',').length}</Grid>
              </Grid>
            </Grid>
            }
          </div>
        }
        {
          <Grid container alignContent={'flex-start'} spacing={0}
                direction={'row'}
                onClick={onClickAction(action)}
                style={{
                  margin: 0, padding: '2.5px 0', backgroundColor: '#F3F3F3', textAlign: 'left',
                  border: `${action.importance >= 0 && 2 || 1}px 
                  ${'solid'} 
                  ${action.importance === 1 && EurestoColor('EurestoError') || action.importance === 0 && EurestoColor('EurestoPrimary') || EurestoColor('disabled', '')}`,
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                  cursor: 'pointer'
                }}>
            <Grid item style={{
              margin: 0, padding: 2.5, backgroundColor: 'white'
            }}>
              <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} spacing={0}
                    style={{ margin: 0, padding: 0 }}>
                <i
                  className={`fa-2x ei-${action.type_action_id === Constants.typeAction.EmailRecu && 'commun_notification_email'
                  || action.type_action_id === Constants.typeAction.EmailEnvoi && 'crm_campagne_email'
                  || action.type_action_id === Constants.typeAction.SmsRecu && 'commun_notification_sms'
                  || action.type_action_id === Constants.typeAction.SmsEnvoi && 'crm_campagne_sms'
                    }`}/></Grid>
            </Grid>
            <Grid item xs
                  style={{
                    margin: 0, padding: 0
                  }}>
              <Grid container alignContent={'flex-start'} spacing={0}
                    direction={'row'}
                    style={{
                      margin: 0, padding: 0
                    }}>
            <span style={{
              fontSize: '12px',
              margin: '0px 2px',
              lineHeight: 1.2
            }}>
              <i
                style={{
                  fontSize: '12px',
                  margin: 0,
                  lineHeight: .9
                }}>
                <b style={{
                  fontSize: '12px',
                  margin: 0,
                  lineHeight: .9
                }}>{props.object.contact_libelle}</b>
                &nbsp;le <i
                className={'fa fa-clock-o EurestoPrimary--text'}/>{moment(action.date_creation).format('DD[/]MM[/]YY LT')} {action.date_creation !== action.date_modification &&
              <span>&nbsp;<i
                className={'ei-commun_modifier EurestoSecondary--text'}/>{moment(action.date_modification).format('DD[/]MM[/]YY LT')}</span>}
              </i>
                <Grid
                  style={{
                    lineHeight: .9
                  }}
                  alignContent={'center'}
                  direction={'row'}
                  container>
                  {
                    (action.flags || []).map(flag => <EmojiEuresto flag={flag}/>)
                  }
                  {action.user_assign_id && <i
                    style={{
                      fontSize: 12,
                      margin: '0px 2px',
                    }}>{(action.flags || []).length > 0 && ', assigné' || 'Assigné '} à
                    {userAssignAction(action)}
                    {
                      (action.date_echeance || action.date_traitement)
                      && <span>, prévu pour le {dateInterventionAction(action)}</span> || ``}
                  </i>}
                </Grid>
              </span>
              </Grid>
            </Grid>
          </Grid>}
      </Grid>
    )
  }

  const userAssignAction = (action) => {
    const couldUpdateUserAssign = ((Data.get(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur, { id: action.user_assign_id }) || {})
      .utilisateurs || []).indexOf(User.User.get().id) !== -1
    return (
      <i className={'EurestoPrimary--text anchorElementUserAssign'}
         aria-owns={anchorUserAssignActionEl[action.id] ? 'action-menu-user-assign-' + action.id : null}
         aria-haspopup="true"
         style={{
           borderRadius: 5,
           margin: '0px 2px',
           //cursor: (couldUpdateUserAssign || !action.user_assign_id) && 'pointer' || 'not-allowed'
         }}>
        <b
          className={'anchorElementUserAssign ' + (action.etat !== 1 && 'EurestoError--text' || 'EurestoPrimary--text')}>
          {(groupeUserOptions.find(grp => grp.value === action.user_assign_id) || {}).label || 'personne'}
        </b>
        <Menu
          style={{ paddingRight: 5, paddingLeft: 5 }}
          id={'action-menu-user-assign-' + action.id}
          keepMounted
          anchorEl={anchorUserAssignActionEl[action.id] || null}
          open={Boolean(anchorUserAssignActionEl[action.id]) || false}
          onClose={(event) => handleCloseElUserAssignAction(event, action.id)}>
          <MenuList>
            <ListingModal
              hideHeader
              name={'user_assign_id'}
              style={{
                //height: User.CalculHeight.getHeightWanted(300),
                maxHeight: User.CalculHeight.getHeightWanted(300),
              }}
              inputStyle={{
                marginBottom: 0
              }}
              title={EurestoI18n.t('crm:Assignée à')}
              value={action.user_assign_id}
              data={action.user_assign_id && groupeUserOptions.filter(r => !r.archive_id && r.groupe_id === action.user_assign_id) || groupeUserOptions}
              libelle={''}/>
          </MenuList>
        </Menu>
      </i>
    )
  }

  const dateInterventionAction = (action) => {
    return (
      <i className={'EurestoPrimary--text anchorElementDateIntervention'}
         aria-owns={anchorDateInterventionActionEl[action.id] ? 'action-menu-date-intervention-' + action.id : null}
         aria-haspopup="true"
         style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}>
        style={{ borderRadius: 5, margin: '0px 2px', cursor: 'pointer' }}>
        <b
          className={'anchorElementDateIntervention'}>{moment(action.date_traitement || action.date_echeance).format('ddd DD MMM YYYY')}</b>
        <Menu
          style={{ paddingRight: 5, paddingLeft: 5 }}
          id={'action-menu-date-intervention-' + action.id}
          keepMounted
          anchorEl={anchorDateInterventionActionEl[action.id] || null}
          open={Boolean(anchorDateInterventionActionEl[action.id]) || false}
          onClose={(event) => handleCloseElDateInterventionAction(event, action.id)}>
          <MenuList>
            <DatePicker
              onChange={() => console.log('HERE')}
              style={{ marginBottom: 0 }}
              title={<span
                className={'ei-reservation_calendrier'}>&nbsp;{EurestoI18n.t('commun:Date d\'intervention')}</span>}
              id={'propsPicker-' + action.id}
              value={action.date_traitement || action.date_echeance}/>
            {action.date_traitement && action.date_echeance &&
            <i style={{ padding: '0px 5px 0px 2px' }}>Initialement prévu
              pour
              le <b>{moment(action.date_echeance).format('ddd DD MMM YYYY')}</b></i>}
          </MenuList>
        </Menu>
      </i>
    )
  }

  const handleCloseElUserAssignAction = (event, id) => {
    setAnchorUserAssignActionEl({
      ...anchorUserAssignActionEl || {},
      [id]: null
    })
  }

  const handleClickElUserAssignAction = (event, id) => {
    if (event.target.className.indexOf('anchorElementUserAssign') !== -1) {
      setAnchorUserAssignActionEl({
        ...anchorUserAssignActionEl || {},
        [id]: event.target
      })
    }
  }

  const handleCloseElDateInterventionAction = (event, id) => {
    setAnchorDateInterventionActionEl({
      ...anchorDateInterventionActionEl || {},
      [id]: null
    })
  }

  const handleClickElDateInterventionAction = (event, id) => {
    if (event.target.className.indexOf('anchorElementDateIntervention') !== -1) {
      setAnchorDateInterventionActionEl({
        ...anchorDateInterventionActionEl || {},
        [id]: event.target
      })
    }
  }

  return <Grid container style={{
    margin: 0,
    padding: 0,
    maxHeight: User.CalculHeight.getHeightWanted(50),
    height: User.CalculHeight.getHeightWanted(50),
  }} spacing={0} justify={'center'} alignItems={'center'}>
    {/*<SplitPane style={{ position: 'relative' }} split={'horizontal'} defaultSize={'70%'} pane1Style={{
      minHeight: '30%',
      maxHeight: '70%',
    }} pane2Style={{
      minHeight: '30%',
      maxHeight: '70%',
    }}>*/}
    <Grid container style={{
      height: User.CalculHeight.getHeightWanted(50),//'100%',
      margin: 0,
      padding: 0,
      overflowY: 'auto',
      width: '100%',
      background: 'white'
      //paddingTop: 25,
    }} spacing={0} justify={'flex-start'} alignItems={'flex-start'} alignContent={'flex-start'}>
      {actions.map(actionComponent)}
    </Grid>
    {/*<Paper style={{
        backgroundColor: '#F5F5F5',
        width: '100%',
        position: 'relative',
        height: '100%',
        margin: 0,
        //marginTop: 1,
        color: 'inherit',
      }}>
        <Grid container
              style={{ margin: 0, padding: 0, position: 'relative', height: '100%' }}
              spacing={0} direction={'column'}
              justify={'flex-start'} alignItems={'stretch'} wrap={'nowrap'}>
          <Wysiwyg onChange={() => console.log('I change Here !!!')}
                   buttons={[]}
                   maxHeight={'100%'}
                   name='message'
                   value={'test'}/>
        </Grid>
      </Paper>*/}
    {/*</SplitPane>*/}
    {imgs && imgs.length > 0 && <ApercuImage isOpen={imgs && imgs.length > 0} images={imgs}
                                             key={imgs.map(img => img.src).join(',')}
                                             onClose={() => {
                                               setImgs([])
                                             }}/>}
  </Grid>

})


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/Message/Form/index.js